var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "PLANREFUND" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("span", [_vm._v("*")]),
        _vm._v(" "),
        _c("Input", {
          attrs: { type: "textarea", rows: 4, placeholder: "请输入驳回意见" },
          model: {
            value: _vm.textarea,
            callback: function ($$v) {
              _vm.textarea = $$v
            },
            expression: "textarea",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "foot" },
      [
        _c(
          "Button",
          {
            staticClass: "cancel-btn",
            attrs: { disabled: _vm.isDisabled },
            on: { click: _vm.cancel },
          },
          [_c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))])]
        ),
        _vm._v(" "),
        _c(
          "Button",
          {
            staticClass: "sav-btn",
            attrs: { type: "error", disabled: _vm.isDisabled },
            on: { click: _vm.save },
          },
          [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }